// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation SignInMutation($input: SignInInput!) {
    signIn(input: $input) {
      user {
        id
      }
      requiresTwoFactor
      requiresTwoFactorSetup
      twoFactorToken
      setupToken
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
